module.exports = __webpack_public_path__ + "static/img/v21.fe52b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v21.png
// module id = l0rY
// module chunks = 1